import { CreateOrEditCapacityModel } from "../tables/create-or-edit-capacity.model";

export class VenueModel {
    public id : string;
    public pictureUrl:string;
    public name:string ="";
    public phone:string ="";
    public address : string ="";
    public hasCapacity : boolean;
    public capacityConfig: CreateOrEditCapacityModel;
    public latitude: number | undefined;
    public longitude: number | undefined;
    public fiscalPrinterCode: string ="";
}
